import { DetailValueTypeEnumValue } from "@panda0/panda0-graphql/defs";
import { z } from "zod";

import {
  CustomizeStepSchema,
  QuizShareResultsEnumValue,
} from "@/lib/zod/schemas/job";

// Constants
export const ANSWER_TYPES = [
  { value: DetailValueTypeEnumValue.oneline, label: "One Line" },
  { value: DetailValueTypeEnumValue.multiline, label: "Multiple Line" },
  { value: DetailValueTypeEnumValue.radiobutton, label: "Radio Buttons" },
  { value: DetailValueTypeEnumValue.checkbox, label: "Checkboxes" },
] as const;

export const SHARE_RESULTS_OPTIONS = [
  {
    value: QuizShareResultsEnumValue.immediately,
    label: "Immediately after the Quiz has ended",
  },
  {
    value: QuizShareResultsEnumValue.afterJobClosed,
    label: "After the job is closed",
  },
  { value: QuizShareResultsEnumValue.never, label: "Never" },
] as const;

// Default question text for special types
export const DEFAULT_QUESTION_TEXT = {
  Linkedin: "Please provide your LinkedIn profile URL",
  Github: "Please provide your GitHub profile URL",
  URL: "Please provide a URL",
};

export type FormData = z.infer<typeof CustomizeStepSchema>;
